// src/components/AdminTabRoles.js
import React, { useEffect, useState } from "react";
import TabTwoColumnLayout from "../layouts/TabTwoColumnLayout";
import AdminListItem from "../components/AdminListItem";
import { apiFetch } from "../utils/wkCommon";

export default function AdminTabRoles() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        // populate counts (umats, umat_permissions)
        const resp = await apiFetch("/api/umat-roles?populate[0]=umats&populate[1]=umat_permissions&sort=name:asc");
        if (!mounted) return;
        setItems(resp?.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => (mounted = false);
  }, []);

  const filtered = items.filter(it => (it.attributes?.name || "").toLowerCase().includes(q.toLowerCase()));

  const leftList = (
    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
      {loading ? <li>Loading…</li> : filtered.map(it => {
        const a = it.attributes || it;
        const umatsCount = (a.umats?.data || a.umats || []).length;
        const permsCount = (a.umat_permissions?.data || a.umat_permissions || []).length;
        const subtitle = `${umatsCount} umats • ${permsCount} permissions`;
        return <AdminListItem key={it.id} title={a.name} subtitle={subtitle} onClick={() => setSelected(it)} active={selected?.id === it.id} />;
      })}
    </ul>
  );

  const leftControls = <><input placeholder="Search role..." value={q} onChange={e=>setQ(e.target.value)} /><button>+ New</button></>;

  const rightForm = selected ? <div>{selected.attributes?.name}</div> : <div>Pilih role dari kiri.</div>;

  return <TabTwoColumnLayout leftControls={leftControls} leftList={leftList} rightForm={rightForm} />;
}
